import { render } from "./CogsDataTopSection.vue?vue&type=template&id=23910eb2&scoped=true"
import script from "./CogsDataTopSection.vue?vue&type=script&lang=js"
export * from "./CogsDataTopSection.vue?vue&type=script&lang=js"

import "./CogsDataTopSection.vue?vue&type=style&index=0&id=23910eb2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23910eb2"]])

export default __exports__